import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./header/header";
import { Homepage } from "./views/homepage/homepage";
import { Contact } from "./views/contact/contact";
import { PrivacyPolicy } from "./views/privacyPolicy/privacyPolicy";
import Footer from "./Footer/Footer";

type State = {
  fileKeys: string[];
};

export class App extends React.Component<{}, State> {
  state: State = {
    fileKeys: [],
  };

  componentDidMount() {
    const markdownFiles = require.context(
      "content/caseStudies",
      false,
      /\.\/.*md/i
    );

    this.setState({
      fileKeys: markdownFiles.keys(),
    });
  }

  render() {
    if (!this.state) return;

    return (
      <div className="App flex flex-col min-h-screen">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/home" element={<Homepage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </div>
    );
  }
}
